import axios from "axios";
import moment from "moment";
import store from "../../../redux/store";
import { Tracker } from "../../util/analytics";
import { API_ENDPOINT_BASE_URL } from "../../util/constants";
import * as helpers from "../../util/helpers";
import { getDialerTypeOfQueue } from "../../util/queueUtil";
import { getIsSipCall, getQueueName, isAgentEvent } from "./api";
import * as c2cConstants from "./constants";
import * as constants from "./constants";
import {
  getAgentPhoneForCalling,
  getSessionUserId,
  getSetting
} from "./helpers";
import {
  actionTypes,
  getInitialCallStates,
  REQ_STATE,
  TRANSFER_TYPE
} from "./reducer";
import { setSnackbar } from "../../../redux/snackbar";

let tcFlag = false;
let conference_agent_call = {};
export const getCustomerApi = async (phone_number) => {
  const data = {
    limit: 20,
    offset: 0,
    total_pages: 1,
    total_entries: 1,
    phonebook__phonenumbers_set__number__istartswith: phone_number,
  };
  return await callAPi("/newsr/api/v1/customer/", "GET", data);
};

export const getCustomerNameApi = async (phone_number, callEvent) => {
  const userId = getSessionUserId();
  const data = {
    user_id: userId,
    srnumber: callEvent["knowlarity_number"],
    number: phone_number,
  };
  const response = await callAPi("/newsr/get_contact_from_crm/", "GET", data);

  if (response.status === 200) {
    return response.data["customer_name"];
  }
  return "Unknown";
};

export const initializeCallService = (params) => {
  if (helpers.isAgent()) {
    const client = getClient();
    return client;
  }
  return null;
};

export const handleCallServiceMessage = async (callEvent, params, dispatch) => {
  const ticker = getTickerState();

  if (!callEvent) return;
  let LTAG =
    "ICSSS [TICKER][" +
    callEvent["event_type"] +
    "] " +
    "[" +
    callEvent["agent_number"] +
    "] ";

  if (
    callEvent &&
    callEvent["call_solution"] !== "obdcc" &&
    callEvent["event_type"] === "BRIDGE"
  ) {
    return;
  }
  if (
    callEvent &&
    callEvent["event_type"] &&
    (constants.TICKER_MODE === "mock" ||
      (ticker.callInitialEvent &&
        ticker.callInitialEvent.uuid === callEvent["uuid"]) ||
      isAgentEvent(callEvent, dispatch))
  ) {
    let cf = await getCallFlowService(callEvent, dispatch, null);

    let payload = cf.getState();
    delete payload["logs"];
    if (cf.state.isCallInitialEvent) {
      const isSameAgentInWsKonnect = getAgentPhoneForCalling(ticker.session_agent) === callEvent["agent_number"];
      if(isSameAgentInWsKonnect && helpers.isFeatureEnabledProfile('sip_url_flag') && !helpers.isFeatureEnabledProfile("remove_konnect_dependency")) { 
        helpers.wsKonnectSyncTracker('konnectKey', callEvent["uuid"]);
      }
      dispatch({
        type: "onCallEvent",
        payload: payload,
      });

      if (
        !cf.state.deferredOpenWindow &&
        (cf.state.call_state === constants.CALL_STATES.CALL_INITIATED ||
          cf.state.call_state === constants.CALL_STATES.CALL_CONNECTED)
      ) {
        dispatch({ type: "Open", payload: {} });
      }
    } else {
      if (cf && (constants.TICKER_MODE === "mock" || cf.isEventValid())) {
        dispatch({ type: "onCallEvent", payload: payload });
        if (
          !cf.state.deferredOpenWindow &&
          (cf.state.call_state === constants.CALL_STATES.CALL_INITIATED ||
            cf.state.call_state === constants.CALL_STATES.CALL_CONNECTED) &&
          getAgentPhoneForCalling(ticker.session_agent) ===
            callEvent["agent_number"]
        ) {
          dispatch({ type: "Open", payload: {} });
        }
      }
    }
  }
};

export function getCallInitialEvent() {
  const ticker = store.getState().ticker;

  return ticker["callInitialEvent"];
}

export function getTickerState() {
  const ticker = store.getState().ticker;
  return ticker;
}

const serviceMap = {};

export const getCallFlowService = async (callEvent, dispatch, handler) => {
  let engine = serviceMap["callFlow"];
  if (!engine) {
    engine = new CallFlow(callEvent, dispatch, handler);
    serviceMap["callFlow"] = engine;
  }

  await engine.setEvent(callEvent, dispatch, handler);
  return engine;
};

export const getCallFlowServiceReadonly = async (
  callEvent,
  dispatch,
  handler
) => {
  let engine = serviceMap["callFlow"];
  if (!engine) {
    engine = new CallFlow(callEvent, dispatch, handler);
    serviceMap["callFlow"] = engine;
    await engine.setEvent(callEvent, dispatch, handler);
  } else {
    engine.refreshState();
  }

  return engine;
};

export class CallFlow {
  constructor(callEvent, dispatch, handler) {
    const ticker = getTickerState();
    this.ticker = ticker;
    this.dispatch = dispatch;
    this.state = { ...ticker };
    this.isCustomerNameAvailable = false;
  }

  log(data) {
    if (this.dispatch) {
      this.dispatch({ type: "tlog", payload: data });
    } else {
    }
  }

  getState() {
    return this.state;
  }

  async reset(callEvent, dispatch) {
    return;
  }

  refreshState() {
    const ticker = getTickerState();
    this.ticker = ticker;
    this.state = { ...ticker };
  }

  async setEvent(callEvent, dispatch, handler) {
    const ticker = getTickerState();
    this.ticker = ticker;
    this.state = { ...ticker };
    this.dispatch = dispatch;

    if (!callEvent) {
      this.state.call_state = constants.CALL_STATES.CALL_NONE;
    }

    if (!callEvent) return;

    this.handler = handler;
    if (!handler) {
      this.handler = (x1, x2) => {};
    }
    if (this.isInitialEvent(callEvent)) {
      let state = this.state;
      let initialCallStates = getInitialCallStates();
      delete initialCallStates.sip_user;
      if (callEvent["uuid"] && 
        this.state.callInitialEvent?.['uuid'] && 
        callEvent["uuid"] !== this.state.callInitialEvent?.['uuid']
      ) {
        if (state.call_state !== constants.CALL_STATES.CALL_HANGUP &&
          !(this.state.dialerType === "predictive" && helpers.isFeatureEnabledProfile('sip_url_flag'))) {
          return;
        }
      }
      this.state = {
        ...state,
        ...initialCallStates,
        isCallInitialEvent: true,
        callInitialEvent: callEvent,
        call_customer_number: callEvent["customer_number"],
      };
    }
    try {
      if (
        callEvent["uuid"] !== this.state.callInitialEvent?.['uuid'] &&
        getAgentPhoneForCalling(this.ticker.session_agent) !== callEvent["agent_number"] && 
        !helpers.isFeatureEnabledProfile('sip_url_flag')
      ) {
        return;
      }
    } catch (error) {
      console.log("Error in getting callInitialEvent['uuid']: ", error);
    }
    await this.setBasicCallInfo(callEvent);
    await this.getCallState(callEvent);
  }

  getCallSolution(callEvent) {
    let key = callEvent.call_solution;
    key = key.toLowerCase();
    if (key === "inbound" || key === 'ibdcc' || key === "ibd") {
      if (
        !callEvent["variable_cc_queue"] ||
        callEvent["variable_cc_queue"] === ""
      ) {
        key = "inbound_noncc";
      } else {
        key = "inbound_cc";
      }
    }
    this.state.call_solution = key;
    this.state.metadata = constants.CALL_SOLUTIONS[key];
    this.state.solution = constants.CALL_SOLUTIONS[key];
    return this.state.call_solution;
  }

  async setBasicCallInfo(callEvent) {
    this.state.callEvent = callEvent;
    this.getCallSolution(callEvent);

    this.state.call_direction = callEvent.call_direction.toLowerCase();
    this.state.sr_number = callEvent.knowlarity_number;
    this.state.unique_id = callEvent.unique_id;
    this.state.event_type = callEvent.event_type;
    this.state.data = { callEvent: callEvent };
    // Flag added, just to load username once from API.
    if (!this.isCustomerNameAvailable) {
      await this.getCustomerInfo().then((res) => { 
        this.isCustomerNameAvailable = true; 
      });
    }
    if (this.state.call_solution === "obdcc") {
      if (!this.state.dialerType) {
        this.state.dialerType = await getDialerTypeOfQueue(
          callEvent["variable_cc_queue"]
        );
      }
    }
    if (!this.state.call_queue_name && callEvent["variable_cc_queue"]) {
      this.state.call_queue_name = await getQueueName(
        callEvent["variable_cc_queue"]
      );
    }
    this.state.callEvent = callEvent;
  }

  isSipCall = () => {
    if (constants.TICKER_MODE === "mock") {
      return true;
    }
    return getIsSipCall(this.ticker.session_agent);
  };

  getCallProgressState = () => {
    return "";
  };

  getSolution = () => {
    return this.state.solution;
  };

  getCallSolutionName = () => {
    return this.state.call_solution;
  };

  getSRNumber = () => {
    return this.state.callEvent["knowlarity_number"];
  };
  hasQueue = () => {
    return this.state.callEvent["variable_cc_queue"] ? true : false;
  };
  getQueueName = () => {
    return this.state.call_queue_name;
  };

  isInitialEvent(callEvent) {
    this.state.isCallInitialEvent = false;
    switch (this.getCallSolution(callEvent)) {
      case "c2c": {
        switch (callEvent.event_type) {
          case "AGENT_CALL": {
            if (
              getAgentPhoneForCalling(this.ticker.session_agent) ===
                callEvent["agent_number"] ||
              constants.TICKER_MODE === "mock"
            ) {
              this.state.isCallInitialEvent = true;
            }
            break;
          }
          default:
            return;
        }
        break;
      }

      case "inbound_cc": {
        switch (callEvent.event_type) {
          case "ORIGINATE": {
            if (
              !this.ticker.transfer_agent &&
              !this.ticker.conference_agent &&
              getAgentPhoneForCalling(this.ticker.session_agent) ===
                callEvent["agent_number"]
            ) {
              this.state.isCallInitialEvent = true;
            }
            break;
          }

          default:
            return;
        }
        break;
      }
      case "inbound_noncc": {
        switch (callEvent.event_type) {
          case "ORIGINATE": {
            if (
              !this.ticker.transfer_agent &&
              !this.ticker.conference_agent &&
              getAgentPhoneForCalling(this.ticker.session_agent) ===
                callEvent["agent_number"]
            ) {
              this.state.isCallInitialEvent = true;
            }
            break;
          }
          default:
            return;
        }
        break;
      }

      case "obdcc": {
        switch (callEvent.event_type) {
          case "AGENT_CALL": {
            if (
              getAgentPhoneForCalling(this.ticker.session_agent) ===
              callEvent["agent_number"]
            ) {
              if (
                !this.ticker.transfer_agent &&
                !this.ticker.conference_agent
              ) {
                this.state.isCallInitialEvent = true;
              }
              break;
            }
            break;
          }
          default:
            return;
        }
        break;
      }
      default:
        return;
    }

    return this.state.isCallInitialEvent;
  }

  isTCCase = () => {
    const callEvent = this.state.callEvent;
    let isTC =
      this.state.call_type !== "legc_call" &&
      (this.ticker.transfer_agent || this.ticker.conference_agent) &&
      (callEvent.variable_current_application === "att_xfer" ||
        callEvent.variable_current_application === "att_conf" ||
        callEvent.variable_current_application === "conference" ||
        (this.ticker.transfer_agent &&
          getAgentPhoneForCalling(this.ticker.transfer_agent) ===
            callEvent.customer_number) ||
        (this.ticker.transfer_agent &&
          getAgentPhoneForCalling(this.ticker.transfer_agent) ===
            callEvent.agent_number) ||
        (this.ticker.conference_agent &&
          getAgentPhoneForCalling(this.ticker.conference_agent) ===
            callEvent.customer_number) ||
        (this.ticker.conference_agent &&
          getAgentPhoneForCalling(this.ticker.conference_agent) ===
            callEvent.agent_number));
    return isTC;
  };

  isTCHangup = () => {
    const callEvent = this.state.callEvent;
    let isTCH =
      (this.state.legc_event_customer_answer &&
        this.state.legc_event_customer_answer.unique_id ===
          callEvent.unique_id) || 
      ((this.state.unique_id && callEvent.variable_current_application == "legcdisconnect") && 
      this.state.unique_id === callEvent.unique_id) ||
      (this.ticker.transfer_agent &&
        getAgentPhoneForCalling(this.ticker.transfer_agent) ===
          callEvent.customer_number) ||
      (this.ticker.transfer_agent &&
        getAgentPhoneForCalling(this.ticker.transfer_agent) ===
          callEvent.agent_number) ||
      (this.ticker.conference_agent &&
        getAgentPhoneForCalling(this.ticker.conference_agent) ===
          callEvent.customer_number) ||
      (this.ticker.conference_agent &&
        getAgentPhoneForCalling(this.ticker.conference_agent) ===
          callEvent.agent_number);

    return isTCH;
  };

  connectTC = () => {
    const callEvent = this.state.callEvent;
    this.state.legc_event_customer_answer = callEvent;
    switch (this.state.transfer_type) {
      case TRANSFER_TYPE.CONFERENCE: {
        this.state.transfer_state = REQ_STATE.CONNECTED;
        this.state.view_state =
          constants.CALL_VIEW_STATES.CALL_CONFERENCE_CONNECTED_VIEW;
        break;
      }
      case TRANSFER_TYPE.TRANSFER: {
        if (this.state.call_solution === "inbound_cc") {
          if (this.state.callEvent.event_type === "ANSWER") {
            this.state.transfer_state = REQ_STATE.CONNECTED;
            this.state.view_state =
              constants.CALL_VIEW_STATES.CALL_TRANSFER_CONNECTED_VIEW;
          }
        } else {
          this.state.transfer_state = REQ_STATE.CONNECTED;
          this.state.view_state =
            constants.CALL_VIEW_STATES.CALL_TRANSFER_CONNECTED_VIEW;
        }
        break;
      }
      case TRANSFER_TYPE.TRANSFER_TO_QUEUE: {
        this.state.transfer_state = REQ_STATE.CONNECTED;
        this.state.view_state =
          constants.CALL_VIEW_STATES.CALL_TRANSFER_TO_QUEUE_COMPLETED_VIEW;
        break;
      }
      default:
        return;
    }
  };

  hangupTC = () => {
    sessionStorage.removeItem("legcuuid");
    switch (this.state.transfer_type) {
      case TRANSFER_TYPE.CONFERENCE: {
        this.state.transfer_state = REQ_STATE.NONE;
        this.state.transfer_agent = null;
        this.state.conference_agent = null;
        this.state.view_state = constants.CALL_VIEW_STATES.CALL_VIEW;
        tcFlag = false;
        conference_agent_call = {};
        break;
      }
      case TRANSFER_TYPE.TRANSFER: {
        this.state.transfer_state = REQ_STATE.NONE;
        this.state.transfer_agent = null;
        this.state.conference_agent = null;
        this.state.view_state = constants.CALL_VIEW_STATES.CALL_VIEW;
        tcFlag = false;
        conference_agent_call = {};
        break;
      }
      case TRANSFER_TYPE.TRANSFER_TO_QUEUE: {
        this.state.transfer_state = REQ_STATE.NONE;
        this.state.transfer_agent = null;
        this.state.conference_agent = null;
        this.state.view_state = constants.CALL_VIEW_STATES.CALL_VIEW;
        break;
      }

      default:
        return;
    }
  };

  hideTCControlsForLegC = () => {
    if (
      this.state.callEvent["variable_current_application"] === "att_xfer" ||
      this.state.callEvent["variable_current_application"] === "att_conf" ||
      this.state.callEvent["variable_current_application"] === "conference"
    ) {
      this.state.call_type = "legc_call";
      this.state.hide_tc = true;
    }
  }

  checkForWrapup = () => {
    this.isCustomerNameAvailable = false;
    if (
      this.state.view_state === constants.CALL_VIEW_STATES.CALL_ADD_CUSTOMER
    ) {
      this.state.call_state = constants.CALL_STATES.CALL_WRAPUP;
    } else {
      this.state.call_state = constants.CALL_STATES.CALL_HANGUP;
      this.state.view_state = constants.CALL_VIEW_STATES.CALL_NONE;
      this.state.window_state_counter = this.state.window_state_counter + 1;
      this.state.window_state = constants.C2C_CONSTANTS.WINDOW_STATE_CLOSED;
    }
    this.state.transfer_agent = null;
    this.state.conference_agent = null;
    this.state.transfer_type = null;
    this.ticker.conference_agent = null;
    tcFlag = false;
    conference_agent_call = {};
  };

  getCallState = async () => {
    let callEvent = this.state.callEvent;
    let callEventType = false;
    if (this.state.isCallInitialEvent) {
      if (
        this.state.callEvent["variable_current_application"] === "att_xfer" ||
        this.state.callEvent["variable_current_application"] === "att_conf" ||
        this.state.callEvent["variable_current_application"] === "conference"
      ) {
        this.state.call_type = "legc_call";
        this.state.hide_tc = true;
      }
    }

    switch (this.state.call_solution) {
      case "c2c": {
        switch (this.state.callEvent.event_type) {
          case "AGENT_CALL": {
            if (
              getAgentPhoneForCalling(this.ticker.session_agent) ===
                callEvent["agent_number"] ||
              constants.TICKER_MODE === "mock"
            ) {
              
              //for non-sip calls wait till customer_call (to get cust no.)
              if (this.isSipCall()) {
                this.state.call_state = constants.CALL_STATES.CALL_INITIATED;
                //alert('isSipCall')
              } else {
                //this.state.call_state = constants.CALL_STATES.CALL_NONE
              }
              this.state.callInitialEvent = callEvent;
              this.state.isCallInitialEvent = true;
              if(!helpers.isFeatureEnabledProfile("remove_konnect_dependency") && helpers.isFeatureEnabledProfile('sip_url_flag')) {
                this.state.sip_call_event_type = "invited";
              }
              this.state.agentCalled = true;
            } else if (this.isTCCase()) {
              sessionStorage.setItem("legcuuid", this.state.callEvent.unique_id);
            }
            break;
          }

          case "CUSTOMER_CALL": {
            if(this.state.call_type == "legc_call") return;
            if (!this.state.firstCustomerCallEvent && getAgentPhoneForCalling(this.ticker.session_agent) === callEvent["agent_number"]) {
              this.state.firstCustomerCallEvent = callEvent;
              this.state.customerCalled = true;
              this.state.call_customer_number = callEvent.customer_number;
              await this.getCustomerInfo(true);

              if (!this.isSipCall()) {
                this.state.call_state = constants.CALL_STATES.CALL_INITIATED;
              }
              if (
                this.state.callEvent["variable_current_application_type"] === "bdtmf"
              ) {
                this.state.is_bdtmf = true;
                this.state.hide_tc = true;
              } else {
                this.state.is_bdtmf = false;
                this.state.hide_tc = true;
              }
            }

            break;
          }
          case "CUSTOMER_ANSWER":
          case "AGENT_ANSWER": {
            //case 'BRIDGE':
            if (this.isTCCase()) {
              if (this.state.callEvent.event_type === "CUSTOMER_ANSWER") {
                if (!this.state.customerAnswerEvent)
                  this.state.customerAnswerEvent = callEvent;
              }

              if (this.state.callEvent.event_type === "AGENT_ANSWER") {
                this.state.agentAnswered = true;
                if (!this.state.agentAnswerEvent) {
                  this.state.agentAnswerEvent = callEvent;
                  this.state.firstCallAnswerEvent = callEvent;
                }
              }

              if(tcFlag && conference_agent_call) {
                this.ticker.conference_agent = conference_agent_call;
                  const cf = await getCallFlowServiceReadonly(callEvent, this.dispatch);
                  mergeAgentToConference(cf, conference_agent_call, this.dispatch).then(res => {
                  if(res) this.connectTC();
                  })
              } else {
                this.connectTC();
              }
            } else {
              if(helpers.isFeatureEnabledProfile("remove_konnect_dependency") && this.isSipCall()) { 
                // Need to add this check because, while the flag is false, we are getting CUSTOMER_ANSWER with a key variable_current_application = "conference" on legA (in konnect events).
                this.hideTCControlsForLegC();
              }
              if (callEvent.event_type === "CUSTOMER_ANSWER") {

                if(tcFlag && conference_agent_call) {
                  const cf = await getCallFlowServiceReadonly(callEvent, this.dispatch);
                  mergeAgentToConference(cf, conference_agent_call, this.dispatch)
                }

                if (!this.state.customerAnswerEvent) {
                  this.state.customerAnswerEvent = callEvent;

                  if (this.state.call_type !== "legc_call" && getAgentPhoneForCalling(this.ticker.session_agent) ===
                  callEvent["agent_number"]) {
                    callEventType = "call_started";

                    if(this.state.callEvent.variable_current_application_type === "bdtmf") {
                      this.state.hide_tc = false;
                      this.state.is_bdtmf = true;
                    } else {
                      this.state.hide_tc = true;
                      this.state.is_bdtmf = false;
                    }

                    this.state.call_customer_number = callEvent.customer_number;
                    this.state.call_state =
                      constants.CALL_STATES.CALL_CONNECTED;
                    this.state.view_state =
                      constants.CALL_VIEW_STATES.CALL_VIEW;
                  }
                  if (this.state.call_type === "legc_call") {
                    this.state.call_state = constants.CALL_STATES.CALL_CONNECTED;
                    this.state.view_state = constants.CALL_VIEW_STATES.CALL_VIEW;
                  }
                  await this.getCustomerInfo(true);
                } else if (this.state.callEvent.variable_current_application_type !== "bdtmf") {
                  this.state.hide_tc = true;
                }
              }

              if (callEvent.event_type === "AGENT_ANSWER") {
                if (this.state.callEvent.event_type === "AGENT_ANSWER") {
                  this.state.agentAnswered = true;
                  if (!this.state.agentAnswerEvent) {
                    this.state.agentAnswerEvent = callEvent;
                    this.state.firstCallAnswerEvent = callEvent;
                  }
                }

                if (this.state.call_type === "legc_call") {
                  this.state.eventsMap["CUSTOMER_ANSWER"] = callEvent;
                  this.state.call_state = constants.CALL_STATES.CALL_CONNECTED;
                  this.state.view_state = constants.CALL_VIEW_STATES.CALL_VIEW;
                }
              }
            }
            break;
          }

          case "HANGUP": {
            if (
              this.state.call_state !== constants.CALL_STATES.CALL_CONNECTED ||
              (this.state.sip_command &&
                this.state.sip_command.type === "reject")
            ) {
              this.checkForWrapup();
              break;
            }
            if (
              this.state.call_type === "legc_call" && callEvent.variable_current_application !== "legcdisconnect" &&
              getAgentPhoneForCalling(this.ticker.session_agent) ===
                callEvent["agent_number"]
            ) {
              this.checkForWrapup();
              break;
            }
            if(callEvent.variable_current_application == "legcdisconnect" || callEvent["leg_identifier"] == 'customer') {
              this.state.call_type = '';
              this.state.hide_tc = false;
            }
            if (this.isTCHangup()) {
              this.hangupTC();
            } else {
              if (
                getAgentPhoneForCalling(this.ticker.session_agent) ===
                callEvent["agent_number"] && callEvent["leg_identifier"] !== 'customer'
              ) {
                this.checkForWrapup();
              }
              break;
            }
            break;
          }
          default:
            return;
        }

        break;
      }

      case "inbound_cc": {
        switch (this.state.event_type) {
          case "ORIGINATE": {
            if (
              !this.ticker.transfer_agent &&
              !this.ticker.conference_agent &&
              getAgentPhoneForCalling(this.ticker.session_agent) ===
                callEvent["agent_number"]
            ) {
              
              this.state.call_state = constants.CALL_STATES.CALL_INITIATED;
              this.state.callInitialEvent = callEvent;
              this.state.isCallInitialEvent = true;
              if(!helpers.isFeatureEnabledProfile("remove_konnect_dependency") && helpers.isFeatureEnabledProfile('sip_url_flag')) {
                this.state.sip_call_event_type = "invited";
              }
              this.state.call_customer_number = callEvent.customer_number;
              this.handler(this, this.state.call_state);
              this.state.agentCalled = true;
            }
            await this.getCustomerInfo(true);
            break;
          }

          case "ANSWER": {
            if (!this.state.firstCallAnswerEvent) {
              this.state.firstCallAnswerEvent = callEvent;
            }
            if (this.isTCCase()) {
              if(callEvent?.additionalinfo && callEvent?.additionalinfo?.includes("legcbridge")) return;
              if(tcFlag && conference_agent_call) {
                const cf = await getCallFlowServiceReadonly(callEvent, this.dispatch);
                mergeAgentToConference(cf, conference_agent_call, this.dispatch).then(res => {
                if(res) this.connectTC();
                })
              } else {
                this.connectTC();
              }
            } else {
              if (
                getAgentPhoneForCalling(this.ticker.session_agent) ===
                callEvent["agent_number"]
              ) {
                this.state.agentAnswered = true;
                callEventType = "call_started";
                this.state.customerAnswerEvent = callEvent;
                this.state.call_state = constants.CALL_STATES.CALL_CONNECTED;
                this.state.view_state = constants.CALL_VIEW_STATES.CALL_VIEW;
                this.state.call_customer_number = callEvent.customer_number;
                this.hideTCControlsForLegC();
              }
            }

            if (this.state.call_type === "legc_call") {
              if (
                getAgentPhoneForCalling(this.ticker.session_agent) ===
                callEvent["agent_number"]
              ) {
                this.state.call_state = constants.CALL_STATES.CALL_CONNECTED;
                this.state.view_state = constants.CALL_VIEW_STATES.CALL_VIEW;
              }
            }

            break;
          }

          case "HANGUP": {
            if (
              this.state.sip_command &&
              this.state.sip_command.type === "reject"
            ) {
              this.checkForWrapup();
              break;
            }

            if (this.isTCHangup()) {
              this.hangupTC();
            } else {
              if (
                getAgentPhoneForCalling(this.ticker.session_agent) ===
                callEvent["agent_number"]
              ) {
                this.checkForWrapup();
              }
            }
            break;
          }

          default:
            return;
        }
        break;
      }

      case "obdcc": {
        switch (this.state.event_type) {
          case "AGENT_CALL": {
            if (!this.state.firstAgentCallEvent) {
              this.state.firstAgentCallEvent = callEvent;
            }

            if (this.state.dialerType === "predictive") {
              this.state.hide_tc = true;
            }

            if (
              getAgentPhoneForCalling(this.ticker.session_agent) ===
                callEvent["agent_number"] ||
              constants.TICKER_MODE === "mock"
            ) {

              if (this.isSipCall()) {
                this.state.call_state = constants.CALL_STATES.CALL_INITIATED;
              } else {
                this.state.deferredOpenWindow = true;
                this.state.call_state = constants.CALL_STATES.CALL_NONE;
              }
              
              this.state.callInitialEvent = callEvent;
              this.state.isCallInitialEvent = true;
              if(!helpers.isFeatureEnabledProfile("remove_konnect_dependency") && helpers.isFeatureEnabledProfile('sip_url_flag')) {
                this.state.sip_call_event_type = "invited";
              }
              this.state.agentCalled = true;
            }

            break;
          }

          case "CUSTOMER_CALL": {

            if (this.state.call_type !== "legc_call" && getAgentPhoneForCalling(this.ticker.session_agent) === callEvent["agent_number"]) {
              this.state.customerCalled = true;
              this.state.call_customer_number = callEvent.customer_number;
              await this.getCustomerInfo(true);
              this.state.call_state = constants.CALL_STATES.CALL_INITIATED;
              this.state.deferredOpenWindow = false;
            }

            break;
          }

          case "AGENT_ANSWER": {
            if (this.isTCCase()) {
              if(callEvent?.additionalinfo && callEvent?.additionalinfo?.includes("legcbridge")) return;
              if(tcFlag && conference_agent_call) {
                const cf = await getCallFlowServiceReadonly(callEvent, this.dispatch);
                mergeAgentToConference(cf, conference_agent_call, this.dispatch).then(res => {
                if(res) this.connectTC();
                })
              } else {
                this.connectTC();
              }
            }

            if (
              getAgentPhoneForCalling(this.ticker.session_agent) ===
              callEvent["agent_number"]
            ) {
              this.state.agentAnswered = true;
              if (!this.state.agentAnswerEvent) this.state.agentAnswerEvent = callEvent;
              this.hideTCControlsForLegC();
              if (this.state.call_type === "legc_call") {
                this.state.deferredOpenWindow = false;
                this.state.call_customer_number = callEvent.customer_number;
                await this.getCustomerInfo(true);
                this.state.customerCalled = true;
                if (!this.state.customerAnswerEvent) {
                  this.state.customerAnswerEvent = callEvent;
                }
                callEventType = "call_started";
                this.state.call_state = constants.CALL_STATES.CALL_CONNECTED;
                this.state.view_state = constants.CALL_VIEW_STATES.CALL_VIEW;
              }
              this.handler(this, this.state.call_state);
            }

            break;
          }
          case "CUSTOMER_ANSWER":
          case "BRIDGE": {
            if (this.isTCCase()) {
            } else {
              // if(callEvent['event_type'] == 'BRIDGE') {
                this.state.firstAgentCallEvent = callEvent;
              // }
              if (
                getAgentPhoneForCalling(this.ticker.session_agent) ===
                callEvent["agent_number"]
              ) {
                if (this.state.dialerType === "predictive") {
                  if (this.state.callEvent.event_type === "BRIDGE") {
                    this.state.agentAnswered = true;
                    callEventType = "call_started";
                    this.state.customerAnswerEvent = callEvent;

                    this.state.call_state =
                      constants.CALL_STATES.CALL_CONNECTED;
                    this.state.call_customer_number = callEvent.customer_number;
                    await this.getCustomerInfo(true);

                    this.state.customerCalled = true;
                    if (!this.state.customerAnswerEvent) {
                      this.state.customerAnswerEvent = callEvent;
                    }
                  }
                } else {
                  if (this.state.call_type !== "legc_call") {
                    callEventType = "call_started";
                    this.state.call_state =
                      constants.CALL_STATES.CALL_CONNECTED;
                    this.state.view_state =
                      constants.CALL_VIEW_STATES.CALL_VIEW;
                  }
                  this.state.call_customer_number = callEvent.customer_number;
                  await this.getCustomerInfo(true);
                  this.state.customerCalled = true;
                  this.state.agentAnswered = true;
                  if (!this.state.customerAnswerEvent) {
                    this.state.customerAnswerEvent = callEvent;
                  }
                }
              }
            }

            if (
              this.state.call_type === "legc_call" &&
              getAgentPhoneForCalling(this.ticker.session_agent) ===
                callEvent["agent_number"]
            ) {
              this.state.call_customer_number = callEvent.customer_number;
              await this.getCustomerInfo(true);
              this.state.customerCalled = true;
              if (!this.state.customerAnswerEvent) {
                this.state.customerAnswerEvent = callEvent;
              }

              this.state.call_state = constants.CALL_STATES.CALL_CONNECTED;
              this.state.view_state = constants.CALL_VIEW_STATES.CALL_VIEW;
            }
            this.handler(this, this.state.call_state);
            break;
          }

          case "HANGUP": {
            if (
              this.state.sip_command &&
              this.state.sip_command.type === "reject"
            ) {
              this.checkForWrapup();

              if (this.handler) this.handler(this, this.state.call_state);
              break;
            }

            if (this.state.call_type === "legc_call") {
              this.checkForWrapup();
              break;
            }

            if (this.isTCHangup()) {
              this.hangupTC();
            } else {
              if (this.state.dialerType === "predictive") {
                if (
                  callEvent["leg_identifier"] === "customer" &&
                  this.state.call_state === constants.CALL_STATES.CALL_CONNECTED
                ) {
                  if (
                    this.state.customerAnswerEvent &&
                    this.state.dialerType === "predictive"
                  ) {
                    if (
                      this.state.customerAnswerEvent.customer_number !==
                      callEvent.customer_number
                    ) {
                      //sometime we are receiving wrong hangups - as obdcc/predictive tries multiple customers at the same time
                      // so ignore any hangups - and focus only on current live call customer
                      return;
                    } else {
                      this.state.customer = null;
                      this.state.call_state =
                        constants.CALL_STATES.CALL_INITIATED;
                    }
                  }
                }

                if (callEvent["leg_identifier"] === "agent") {
                  this.checkForWrapup();
                }
              } else {
                if (
                  getAgentPhoneForCalling(this.ticker.session_agent) ===
                  callEvent["agent_number"]
                ) {
                  this.checkForWrapup();
                }
              }
            }
            break;
          }
          default:
            return;
        }
        break;
      }

      case "inbound_noncc": {
        switch (this.state.event_type) {
          case "ORIGINATE": {
            if (!this.ticker.transfer_agent && !this.ticker.conference_agent && !tcFlag && getAgentPhoneForCalling(this.ticker.session_agent) === callEvent["agent_number"]) {
              
              this.state.call_state = constants.CALL_STATES.CALL_INITIATED;
              this.state.callInitialEvent = callEvent;
              this.state.isCallInitialEvent = true;
              if(!helpers.isFeatureEnabledProfile("remove_konnect_dependency") && helpers.isFeatureEnabledProfile('sip_url_flag')) {
                this.state.sip_call_event_type = "invited";
              }
              this.state.call_customer_number = callEvent.customer_number;
              this.handler(this, this.state.call_state);
            }
            break;
          }

          case "ANSWER": {
            if (!this.state.firstCallAnswerEvent) {
              this.state.firstCallAnswerEvent = callEvent;
            }
            if(tcFlag && conference_agent_call) {
              this.ticker.conference_agent = conference_agent_call;
            }
            if (this.isTCCase()) {
              
              if(tcFlag && conference_agent_call) {
                const cf = await getCallFlowServiceReadonly(callEvent, this.dispatch);
                mergeAgentToConference(cf, conference_agent_call, this.dispatch).then(res => {
                if(res) this.connectTC();
                })
              } else {
                this.connectTC();
              }
            } else {
              if(helpers.isFeatureEnabledProfile("remove_konnect_dependency")) { 
                // Need to add this check because, while the flag is false, we are getting ANSWER with a key variable_current_application = "conference" on legA (in konnect events).
                this.hideTCControlsForLegC();
              }
              if (
                getAgentPhoneForCalling(this.ticker.session_agent) ===
                callEvent["agent_number"]
              ) {
                if (this.state.call_type !== "legc_call") {
                  if (
                    this.state.callEvent["variable_current_application_type"] ===
                    "bdtmf"
                  ) {
                    this.state.is_bdtmf = true;
                    this.state.hide_tc = false;
                  } else {
                    this.state.is_bdtmf = false;
                    this.state.hide_tc = true;
                  }
                }

                callEventType = "call_started";
                this.state.eventsMap["CUSTOMER_ANSWER"] = callEvent;
                this.state.customerAnswerEvent = callEvent;
                this.state.call_state = constants.CALL_STATES.CALL_CONNECTED;
                this.state.call_customer_number = callEvent.customer_number;
                await this.getCustomerInfo(true);
              }
            }

            if (this.state.call_type === "legc_call") {
              if (
                getAgentPhoneForCalling(this.ticker.session_agent) ===
                callEvent["agent_number"]
              ) {
                this.state.call_state = constants.CALL_STATES.CALL_CONNECTED;
                this.state.view_state = constants.CALL_VIEW_STATES.CALL_VIEW;
              }
            }

            this.handler(this, this.state.call_state);
            break;
          }
          case "BRIDGE": {
            break;
          }

          case "HANGUP": {
            if (
              this.state.call_state !== constants.CALL_STATES.CALL_CONNECTED ||
              (this.state.sip_command &&
                this.state.sip_command.type === "reject")
            ) {
              this.checkForWrapup();

              if (this.handler) this.handler(this, this.state.call_state);
              break;
            }
            if(callEvent.variable_current_application == "legcdisconnect") {
              this.state.call_type = '';
              this.state.hide_tc = false;
            }
            if (this.isTCHangup()) {
              this.hangupTC();
            } else {
              if (
                getAgentPhoneForCalling(this.ticker.session_agent) ===
                callEvent["agent_number"]
              ) {
                this.checkForWrapup();
              }
            }
            break;
          }

          default:
            return;
        }
        break;
      }
      default:
        return;
    }

    if (this.state.isCallInitialEvent) {
      if (
        this.state.callEvent["variable_current_application"] === "att_xfer" ||
        this.state.callEvent["variable_current_application"] === "att_conf" ||
        this.state.callEvent["variable_current_application"] === "conference"
      ) {
        this.state.call_type = "legc_call";
        this.state.hide_tc = true;
      }
    }

    if (callEventType === "call_started" || !this.state.call_start_time) {
      this.state.call_start_time = moment();
    }

    if (this.state.callInitialEvent)
      this.state.call_unique_id = this.state.callInitialEvent["uuid"];
  };

  isEventValid = () => {
    if (!this.state.callEvent || !this.state.callInitialEvent) return false;
    return true;
  };

  isIncoming = () => {
    if (this.state.callEvent.call_direction.toLowerCase() === "inbound") {
      return true;
    }

    return false;
  };

  hasAgentAnswered = () => {
    if (
      this.state.events &&
      (this.state.events["ANSWER"] || this.state.events["AGENT_ANSWER"])
    ) {
      return true;
    }

    return false;
  };

  isCustomerCalled = () => {
    if (
      this.state.events &&
      (this.state.events["CUSTOMER_CALL"] || this.state.events["CUSTOMER_CALL"])
    ) {
      return true;
    }

    return false;
  };

  isOutgoing = () => {
    if (this.state.callEvent.call_direction.toLowerCase() === "outbound") {
      return true;
    }

    return false;
  };

  getCustomerInfo = async (force) => {
    if (
      force ||
      this.state.call_customer_number !==
      this.state.callEvent["customer_number"] ||
      !this.state["customer"] ||
      this.state["customer"]["loaded"] === false
    ) {
      if (
        this.state.call_customer_number &&
        this.state.call_customer_number !== "+100000000000" && 
        this.state.call_customer_number !== "+1000000#####"
      ) {
        // Fetching name of the customer, while on call. 
        if (!this.state['customer'] || this.state?.customer?.name === "Unknown" || this.state?.customer?.name === undefined) {
          const customerName = await getCustomerNameApi(
            this.state.call_customer_number,
            this.state.callEvent
          );
          this.state['customer'] = { name: customerName };
        }
      } else {
        this.state["customer"] = { loaded: false, id: null, name: "Unknown" };
      }
    }

    return this.state["customer"];
  };

  getCustomerName = () => {
    const ticker = getTickerState();

    let name =
      ticker["customer"] && ticker["customer"]["name"]
        ? ticker["customer"]["name"]
        : "Unknown";
    const arr = name.split(" ");
    return arr.join(" ");
  };

  getCustomerNumber = () => {
    const ticker = getTickerState();
    return ticker.call_customer_number
      ? ticker.call_customer_number
      : ticker.callInitialEvent && ticker.callInitialEvent["customer_number"]
      ? ticker.callInitialEvent["customer_number"]
      : "";
  };

  getCustomerNumber2 = () => {
    return this.state.call_customer_number
      ? this.state.call_customer_number
      : this.state.callInitialEvent["customer_number"]
      ? this.state.callInitialEvent["customer_number"]
      : "";
  };

  getCallStatus = (command) => {};

  //this is called for SIP call disconnect - by clicking of disconnect call btn usually
  callDisconnect = async (dispatch, callback) => {
    if (this.isSipCall()) {
      if (constants.TICKER_MODE === "mock") {
        if (dispatch) {
          const payload = {};
          payload["call_state"] = constants.CALL_STATES.CALL_HANGUP;
          dispatch({ type: "onCallStateChange", payload: payload });
        }

        if (callback) {
          callback(100);
        }
      } else {
        //dispatch to SIP phone
        const payload = { sip_command: { type: "hangup" } };
        dispatch({ type: "onCallStateChange", payload: payload });
      }
    }
  };

  callAction = async (command, params, dispatch, callback) => {
    if (
      command === constants.CALL_COMMANDS.HOLD &&
      params.value === constants.HOLD_STATES.ON_HOLD
    ) {
      const response = await this.state.solution.CALL_ACTIONS.CONFERENCE_HOLD(
        this
      );
      if (response.status === 200 || constants.TICKER_MODE === "mock") {
        if (dispatch) {
          const payload = {};
          payload[constants.CALL_COMMANDS.HOLD] = constants.HOLD_STATES.ON_HOLD;

          dispatch({ type: "onCallStateChange", payload: payload });
        }
        if (callback) {
          callback(
            constants.CALL_COMMANDS.HOLD,
            constants.HOLD_STATES.ON_HOLD,
            this,
            command,
            params
          );
        }
      }

      Tracker.event(
        c2cConstants.ANALYTICS.C2C_HOLD[0],
        c2cConstants.ANALYTICS.C2C_HOLD[1],
        c2cConstants.ANALYTICS.C2C_HOLD[2],
        c2cConstants.ANALYTICS.C2C_HOLD[3],
        helpers.getUser()
      );
    }

    if (
      command === constants.CALL_COMMANDS.HOLD &&
      params.value === constants.HOLD_STATES.ON_UNHOLD
    ) {
      const response = await this.state.solution.CALL_ACTIONS.CONFERENCE_UNHOLD(
        this
      );
      if (response.status === 200 || constants.TICKER_MODE === "mock") {
        if (dispatch) {
          const payload = {};
          payload[constants.CALL_COMMANDS.HOLD] =
            constants.HOLD_STATES.ON_UNHOLD;
          dispatch({ type: "onCallStateChange", payload: payload });
        }

        if (callback) {
          callback(
            constants.CALL_COMMANDS.HOLD,
            constants.HOLD_STATES.ON_UNHOLD,
            this,
            command,
            params
          );
        }
      }

      Tracker.event(
        c2cConstants.ANALYTICS.C2C_HOLD[0],
        c2cConstants.ANALYTICS.C2C_HOLD[1],
        c2cConstants.ANALYTICS.C2C_HOLD[2],
        c2cConstants.ANALYTICS.C2C_HOLD[3],
        helpers.getUser()
      );
    }

    if (
      command === constants.CALL_COMMANDS.MUTE &&
      params.value === constants.MUTE_STATES.ON_MUTE
    ) {
      if (this.isSipCall()) {
        if (constants.TICKER_MODE === "mock") {
          if (dispatch) {
            const payload = {};
            payload[constants.CALL_COMMANDS.MUTE] =
              constants.MUTE_STATES.ON_MUTE;
            dispatch({ type: "onCallStateChange", payload: payload });
          }

          if (callback) {
            callback(
              constants.CALL_COMMANDS.MUTE,
              constants.MUTE_STATES.ON_MUTE,
              this,
              command,
              params
            );
          }
        } else {
          const payload = { sip_command: { type: "mute" } };
          dispatch({ type: "onCallStateChange", payload: payload });
        }
      }

      Tracker.event(
        c2cConstants.ANALYTICS.C2C_MUTE[0],
        c2cConstants.ANALYTICS.C2C_MUTE[1],
        c2cConstants.ANALYTICS.C2C_MUTE[2],
        c2cConstants.ANALYTICS.C2C_MUTE[3],
        helpers.getUser()
      );
    }

    if (
      command === constants.CALL_COMMANDS.MUTE &&
      params.value === constants.MUTE_STATES.NOT_ON_MUTE
    ) {
      if (this.isSipCall()) {
        if (constants.TICKER_MODE === "mock") {
          if (dispatch) {
            const payload = {};
            payload[constants.CALL_COMMANDS.MUTE] =
              constants.MUTE_STATES.NOT_ON_MUTE;
            dispatch({ type: "onCallStateChange", payload: payload });
          }

          if (callback) {
            callback(
              constants.CALL_COMMANDS.MUTE,
              constants.MUTE_STATES.NOT_ON_MUTE,
              this,
              command,
              params
            );
          }
        } else {
          const payload = { sip_command: { type: "unmute" } };
          dispatch({ type: "onCallStateChange", payload: payload });
        }
      }

      Tracker.event(
        c2cConstants.ANALYTICS.C2C_MUTE[0],
        c2cConstants.ANALYTICS.C2C_MUTE[1],
        c2cConstants.ANALYTICS.C2C_MUTE[2],
        c2cConstants.ANALYTICS.C2C_MUTE[3],
        helpers.getUser()
      );
    }

    if (
      command === constants.CALL_COMMANDS.DIALPAD && params.type === "dialpad_input"
    ) {
      if (this.isSipCall()) {
        const payload = { sip_command: { type: params.type, value: params.value } };
        dispatch({ type: "onCallStateChange", payload: payload });
      }
    }

  };
}

export const cancelAddAgentToConference = async (callFlow, agent, dispatch) => {
  const response = await callFlow.state.solution.CALL_ACTIONS.CONFERENCE_CALL_CANCEL(
    callFlow,
    agent
  );
  if (
    (response && response.status === 200) ||
    constants.TICKER_MODE === "mock"
  ) {
    dispatch({
      type: actionTypes.onCallViewState,
      payload: {
        view_state: constants.CALL_VIEW_STATES.CALL_VIEW,
        conference_agent: null,
        transfer_agent: null,
        queue: null,
      },
    });
    return 200;
  } else {
    dispatch({
      type: actionTypes.onCallViewState,
      payload: {
        view_state: constants.CALL_VIEW_STATES.CALL_VIEW,
        conference_agent: null,
        transfer_agent: null,
        queue: null,
      },
    });
    return 400;
  }
};

export const addAgentToConference = async (callFlow, agent, dispatch) => {
  const response1 = await callFlow.state.solution.CALL_ACTIONS.TRANSFER_CALL(
    callFlow,
    agent
  );
  if(!tcFlag && response1 && response1.status === 200) {
    tcFlag = true;
    conference_agent_call = agent;
  }  
  if (
    (response1 && response1.status === 200) ||
    constants.TICKER_MODE === "mock"
  ) {
    // const response = await callFlow.state.solution.CALL_ACTIONS.CONFERENCE_CALL(
    //   callFlow,
    //   agent
    // );
    // !(callFlow.state.call_solution == "inbound_cc" || callFlow.state.call_solution == "obdcc") &&

    if (
      // (response && response.status === 200) || 
      (response1 && response1.status === 200) ||
      constants.TICKER_MODE === "mock"
    ) {
      dispatch({
        type: actionTypes.onCallViewState,
        payload: {
          view_state: constants.CALL_VIEW_STATES.CALL_CONFERENCE_INITIATED_VIEW,
          conference_agent: agent,
          transfer_state: REQ_STATE.INITIATED,
          transfer_type: TRANSFER_TYPE.CONFERENCE,
          transfer_error: 200,
        },
      });
      dispatch({
        type: actionTypes.onCallViewState,
        payload: {
          view_state: constants.CALL_VIEW_STATES.CALL_CONFERENCE_INITIATED_VIEW,
          conference_agent: agent,
          transfer_state: REQ_STATE.INITIATED_STEP2,
          transfer_type: TRANSFER_TYPE.CONFERENCE,
          transfer_error: 201,
          txnid: getTickerState().txnid + 1,
        },
      });
      return response1.status;
    } else {
      dispatch({
        type: actionTypes.onCallViewState,
        payload: {
          view_state: constants.CALL_VIEW_STATES.CALL_VIEW,
          transfer_agent: null,
          transfer_state: REQ_STATE.NONE,
          transfer_type: null,
          transfer_error: 400,
          txnid: getTickerState().txnid + 1,
        },
      });
      return 400;
    }
  } else {
    dispatch({
      type: actionTypes.onCallViewState,
      payload: {
        view_state: constants.CALL_VIEW_STATES.CALL_VIEW,
        transfer_agent: null,
        transfer_state: REQ_STATE.NONE,
        transfer_type: null,
        transfer_error: 400,
        txnid: getTickerState().txnid + 1,
      },
    });
    return 400;
  }
};

export const mergeAgentToConference = async (callFlow, agent, dispatch) => {
  const response = await callFlow.state.solution.CALL_ACTIONS.CONFERENCE_CALL(
    callFlow,
    agent
  );
  if (
    (response && response.status === 200) ||
    constants.TICKER_MODE === "mock"
  ) {
    dispatch({
      type: actionTypes.onCallViewState,
      payload: {
        view_state: constants.CALL_VIEW_STATES.CALL_CONFERENCE_CONNECTED_VIEW,
        conference_agent: agent,
        transfer_state: REQ_STATE.CONNECTED,
        transfer_type: TRANSFER_TYPE.CONFERENCE,
      },
    });

    return 200;
  } else {
    dispatch({
      type: actionTypes.onCallViewState,
      payload: {
        view_state: constants.CALL_VIEW_STATES.CALL_VIEW,
        transfer_agent: null,
        transfer_state: REQ_STATE.NONE,
        transfer_type: null,
      },
    });
    return 400;
  }
};

export const transferCallToAgent = async (callFlow, agent, dispatch) => {
  const response = await callFlow.state.solution.CALL_ACTIONS.TRANSFER_CALL(
    callFlow,
    agent
  );
  if (
    (response && response.status === 200) ||
    constants.TICKER_MODE === "mock"
  ) {
    dispatch({
      type: actionTypes.onCallViewState,
      payload: {
        view_state: constants.CALL_VIEW_STATES.CALL_TRANSFER_INITIATED_VIEW,
        transfer_agent: agent,
        transfer_state: REQ_STATE.INITIATED,
        transfer_type: TRANSFER_TYPE.TRANSFER,
      },
    });
    dispatch({
      type: actionTypes.onCallViewState,
      payload: {
        view_state: constants.CALL_VIEW_STATES.CALL_TRANSFER_INITIATED_VIEW,
        transfer_agent: agent,
        transfer_state: REQ_STATE.INITIATED_STEP2,
        transfer_type: TRANSFER_TYPE.TRANSFER,
      },
    });

    return response.status;
  } else {
    dispatch({
      type: actionTypes.onCallViewState,
      payload: {
        view_state: constants.CALL_VIEW_STATES.CALL_VIEW,
        transfer_agent: null,
        transfer_state: REQ_STATE.NONE,
        transfer_type: null,
      },
    });
    return 400;
  }
};

const malert = (message) => {
  alert(message);
};

export const transferCompleted = async (callFlow, dispatch) => {
  callFlow.callAction(constants.CALL_COMMANDS.CALL_PROGRESS, {
    value: constants.CALL_PROGRESS_STATES.DISCONNECTED,
  });

  gotoInitialView(dispatch);
};

export const gotoInitialView = async (dispatch) => {
  dispatch({
    type: actionTypes.onCallViewState,
    payload: {
      view_state: constants.CALL_VIEW_STATES.CALL_VIEW_INITIAL,
      call_state: constants.CALL_STATES.CALL_NONE,
    },
  });
};

export const transferCallToQueue = async (callFlow, queue, dispatch) => {
  if (!callFlow.state.solution.CALL_ACTIONS.QUEUE_TRANSFER_CALL) {
    malert("Queue transfer ERR-API-404");
    return;
  }

  const response = await callFlow
    .getSolution()
    .CALL_ACTIONS.QUEUE_TRANSFER_CALL(callFlow, queue);
  if (
    (response && response.status === 200) ||
    constants.TICKER_MODE === "mock"
  ) {
    dispatch({
      type: actionTypes.onCallViewState,
      payload: {
        view_state:
          constants.CALL_VIEW_STATES.CALL_TRANSFER_TO_QUEUE_COMPLETED_VIEW,
        transfer_agent: null,
        queue: queue,
        transfer_state: REQ_STATE.INITIATED,
        transfer_type: TRANSFER_TYPE.TRANSFER_TO_QUEUE,
      },
    });
    dispatch({
      type: actionTypes.onCallViewState,
      payload: {
        view_state:
          constants.CALL_VIEW_STATES.CALL_TRANSFER_TO_QUEUE_COMPLETED_VIEW,
        transfer_agent: null,
        queue: queue,
        transfer_state: REQ_STATE.INITIATED_STEP2,
        transfer_type: TRANSFER_TYPE.TRANSFER_TO_QUEUE,
      },
    });
  } else {
    dispatch({
      type: actionTypes.onCallViewState,
      payload: {
        view_state: constants.CALL_VIEW_STATES.CALL_VIEW,
        transfer_agent: null,
        transfer_state: REQ_STATE.NONE,
        transfer_type: null,
      },
    });
  }
};

export const getClient = (params) => {
  let url = `${process.env.REACT_APP_CALL_EVENTS_API_URL}`;

  url =
    "https://konnect.knowlarity.com:8100/update-stream/{{user_api_key}}/konnect";

  if (!url || url === "") {
    return;
  }

  url = url.replaceAll("{{user_api_key}}", getSetting("konnect_user_api_key"));
  const onNext = async (res) => {
    const data1 = await res.json();
    params.handleMessage(data1, params);
  };
  return null;
};

export const ws_handleEvent = (ws_data, params) => {
  var data = ws_data;
  return data;
};

export const callAPi = async (api, method, params) => {
  const url = API_ENDPOINT_BASE_URL + api;
  try {
    if (method === "POST") {
      const response = await axios.post(url, params, {});
      if (response.status === 200) {
        store.dispatch(setSnackbar(true, "success", (response?.data?.message || response?.data?.msg || "Success!!")));
        return response;
      } else {
        return response;
      }
    }

    if (method === "PUT") {
      const response = await axios.put(url, params, {});
      if (response.status === 200) {
        return response;
      } else {
        return response;
      }
    }

    if (method === "GET") {
      const response = await axios.get(url, { params: params });
      if (response.status === 200) {
        return { status: 200, data: response.data };
      } else {
        return response;
      }
    }
  } catch (error) {
    store.dispatch(setSnackbar(true, "error", (error?.response?.data?.error || error?.response?.data?.msg || "Something went wrong!!")));
    return { status: 504, response: error.response, error: error };
  }
};
